module.exports = __webpack_public_path__ + "static/img/AU@3x.ff4597d3.jpg";